import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import HomeLogo from "./Assets/HomeLogo.png"
import Attach from "./Assets/Attach.png"
import WebClientIcon from "./Assets/WebClientIcon.png"
import WebConfiguratorIcon from "./Assets/WebConfiguratorIcon.png"
import DesktopClientIcon from "./Assets/DesktopClientIcon.png"
import DesktopConfiguratorIcon from "./Assets/DesktopConfiguratorIcon.png"

import Header from './Header'
import MainMenu from './MainMenu'
import { Translate } from "./Translator";
import BlueBar from './BlueBar'
import Footer from './Footer'

function Home(){

    const [mRepaint, SetRepaint] = useState()
    const navigate = useNavigate();
    const IsCrmAdmin = (sessionStorage.getItem("UserIsAdmin") === "1" ? true : false);

    function languageChanged(){
        SetRepaint(!mRepaint)
    }

    return(

        <span>
            
            <Header onLanguageChanged={() => languageChanged()}/>

            <MainMenu MainMenuNumber={1} />
                    
            <table className="tenanttable" width="1200" cellPadding={0} cellSpacing={0} align="center">
                <tbody>
                                    
                    <tr className="pagetop3">
                        <td colSpan={4} height="75" valign="bottom">
                            <table width="100%" cellPadding={0} cellSpacing={0} className="down10px" >
                                <tbody>
                                    <tr height="60">
                                        <td width="80" align="left">
                                            <img alt="Home logo" className="HomeLogo pointer" src={HomeLogo} onClick={() => navigate('/')}/>
                                            <span className="bold">{Translate("Installation")}</span>
                                        </td>                                            
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>

                    <tr height="20"/>

                    <tr className="pagetop4">
                        <td className="freespace"/>
                        <td colSpan={4} className="horizontalLine" >
                            <BlueBar/>
                        </td>
                    </tr>

                    <tr height="40"/>
                </tbody>
            </table>

            <table className="width1200" align="center">
                <tbody>
                    <tr>
                        <td color="blue" width="500" className="activetenants">{Translate("Use")}</td>
                        {IsCrmAdmin && <td align="left" className="activetenants">{Translate("Configure")}</td>}
                    </tr>

                    <tr>
                        <td>
                            <img className="pointer" width="200" alt="Cloud icon" src={WebClientIcon} onClick={() => window.open('https://webclient.cloudcti.nl/', '_blank')}/>
                        </td>
                        {IsCrmAdmin &&
                        <td>
                            <img className="pointer" width="200" alt="Cloud icon" src={WebConfiguratorIcon} onClick={() => window.open('https://webconfigurator.cloudcti.nl/', '_blank')}/>
                        </td>
                        }
                    </tr>

                    <tr height="20"/>

                    <tr>
                        <td>
                            <img className="pointer" width="200" alt="Cloud icon" src={DesktopClientIcon} onClick={() => window.open('https://download.cloudcti.nl/files/setups/cloudcticlientsetup.exe', '_blank')}/>
                        </td>
                        {IsCrmAdmin &&
                        <td>
                            <img className="pointer" width="200" alt="Cloud icon" src={DesktopConfiguratorIcon} onClick={() => window.open('https://downloadcloudcti.blob.core.windows.net/files/setups/cloudcticonfigurationsetup.exe', '_blank')}/>
                        </td>
                        }
                    </tr>

                    <tr height="20"/>

                
                    <tr>
                        <td className="bold">{Translate("Documentation")}</td>
                    </tr>

                    <tr height ="20"/>

                    <tr>
                        <td>
                            <img className="" alt="Attach" src={Attach}/>
                            <a className="black" href="https://downloadcloudcti.blob.core.windows.net/files/Docs/CloudCTI%20Client%20Installation%20manual.pdf">CloudCTI Client Installation Manual</a>
                        </td>
                    </tr>

                    <tr height ="20"/>

                    <tr>
                        <td>
                            <img className="" alt="Attach" src={Attach}/>
                            <a className="black" href="https://downloadcloudcti.blob.core.windows.net/files/Docs/CloudCTI%20Client%20Manual.pdf">CloudCTI Client Manual</a>
                        </td>
                    </tr>

                    <tr height="100"/>

                </tbody>
            </table>         

            <Footer/>
            
        </span>    
    )
}

export default Home